import {
  Component,
  HostListener,
  Input,
  OnDestroy,
  OnInit
} from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { MiniUserModel } from '../../../shared/data/models/mini-user.model';
import { Store } from '@ngrx/store';
import * as fromHome from '../../state';
import { ActivatedRoute, Router } from '@angular/router';
import { MarkdownService } from '../../../markdown/markdown.service';
import * as fromRoot from '../../../state';
import { PostBodyModel } from '../../../shared/data/models/post-body.model';
import { EchoLightPostModel } from '../../../shared/data/models/echo-light-Post.model';
import { Lightbox } from 'ngx-lightbox';
import {
  delay,
  distinctUntilChanged,
  skipWhile,
  takeUntil
} from 'rxjs/operators';

@Component({
  selector: 'reposted-post',
  templateUrl: './reposted-post.component.html',
  styleUrls: ['./reposted-post.component.scss']
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class RepostedPostComponent implements OnInit, OnDestroy {
  @Input() echoModel: EchoLightPostModel;

  currentUser$: Observable<MiniUserModel>;
  showProfileCardEvent$ = new BehaviorSubject<boolean>(false);

  private _albums = [];

  lastUrl: string;
  private unSubscribed$ = new Subject();

  constructor(
    private store$: Store<fromHome.State>,
    private _formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private markdownService: MarkdownService,
    private _lightbox: Lightbox,
    private window: Window
  ) {}

  ngOnInit(): void {
    this.currentUser$ = this.store$.select(fromRoot.getMe);

    this.markdownService
      .extractLastUrl(this.echoModel?.body)
      .pipe(
        takeUntil(this.unSubscribed$),
        skipWhile(ur => ur === '')
      )
      .subscribe(lastUrl => {
        this.lastUrl = lastUrl;
      });
  }

  parseBody(body): PostBodyModel {
    let data: any;
    try {
      const parsedbody = JSON.parse(body) as PostBodyModel;
      data = {
        ...parsedbody,
        body: this.markdownService.convertMarkDownForDisplay(parsedbody.body)
      } as PostBodyModel;

      this._albums =
        parsedbody?.images.map(url => {
          return {
            src: url
            // caption: 'post images',
            // thumb: url
          };
        }) || [];
    } catch (e) {
      data = {
        body: this.markdownService.convertMarkDownForDisplay(body)
      };
      this._albums =
        this.echoModel?.images?.map(url => {
          return {
            src: url.url
            // caption: 'post images',
            // thumb: ',/assets/images/profile.jpg'
          };
        }) || [];
    }

    return data;
  }

  // post body
  postClicked(event: any): void {
    const target = event.target;
    if (target.tagName !== 'A') {
      this.router.navigate([
        `${this.echoModel.author.handle}/post/${this.echoModel.Id}`
      ]);
    }
  }

  open(index: number): void {
    this._lightbox.open(this._albums, index);
  }

  showProfileCard(): void {
    this.hideProfileCard();
    this.showProfileCardEvent$
      .pipe(delay(200), distinctUntilChanged())
      .subscribe(_ => {
        this.showProfileCardEvent$.next(true);
      });
  }

  hideProfileCard(): void {
    this.showProfileCardEvent$.next(false);
  }

  @HostListener('document:click', ['$event'])
  public handleClick(event: Event): void {
    if (event.target instanceof HTMLAnchorElement) {
      const element = event.target as HTMLAnchorElement;
      if (
        element.className === 'mentionlink' ||
        element.className === 'hashtagLink'
      ) {
        event.preventDefault();
        const route = element?.getAttribute('href');
        if (route) {
          this.router.navigate([`/${route}`]);
        }
      }
    }
  }

  ngOnDestroy() {
    this.unSubscribed$.next();
    this.unSubscribed$.complete();
  }
}
